// import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import axios from "axios";

// const PurchasePO = () => {
//   const navigate = useNavigate();
//   const [purchases, setPurchases] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [user_id, setUserId] = useState("");
//   const [getSelectedMenu, setSelectedMenu] = useState(
//     localStorage.getItem("selectedMenu") || ""
//   );

//   // Filters state
//   const [filters, setFilters] = useState({
//     vendor: "",
//     invoice: "",
//     purchaseBy: "",
//     date: "",
//   });

//   useEffect(() => {
//     localStorage.setItem("selectedMenu", getSelectedMenu);
//   }, [getSelectedMenu]);

//   // For modal
//   const [selectedPurchase, setSelectedPurchase] = useState([]);
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     const userid = localStorage.getItem("user_id");
//     if (userid) {
//       setUserId(userid);
//     }
//   }, []);

//   useEffect(() => {
//     if (user_id) {
//       fetchPurchases();
//     }
//   }, [user_id]);

//   const fetchPurchases = async (e) => {
//     if (e) e.preventDefault(); // stop form reload

//     setLoading(true);
//     try {
//       const params = {
//         user_id,
//         vendor: filters.vendor,
//         invoice_no: filters.invoice,
//         start_date: filters.purchaseBy,
//         end_date: filters.date,
//       };

//       // remove empty keys
//       Object.keys(params).forEach(
//         (key) =>
//           (params[key] === "" || params[key] === null) && delete params[key]
//       );

//       const response = await axios.get(
//         "https://ims-backend.indevconsultancy.in/admin-panel/purchases/",
//         { params }
//       );

//       setPurchases(response.data || []);
//     } catch (error) {
//       console.error("Error fetching purchases:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // helper for formatting date
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const d = new Date(dateString);
//     return d.toLocaleDateString("en-GB"); // DD/MM/YYYY
//   };

//   const handleExportCSV = () => {
//     const headers = ["S.No.", "Item Name", "Quantity", "Expenditure Date"];
//     const rows = purchases.map((item, index) => [
//       index + 1,
//       `${item.stock_name} (${item.units})`,
//       item.expenditure_quantity,
//       formatDate(item.created_at),
//     ]);

//     const csvContent =
//       "data:text/csv;charset=utf-8," +
//       [headers, ...rows]
//         .map((row) =>
//           row
//             .map((field) =>
//               typeof field === "string" && field.includes(",")
//                 ? `"${field}"`
//                 : field
//             )
//             .join(",")
//         )
//         .join("\n");

//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", "expenditure_list_filtered.csv");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Handle view button click
//   const handleView = async (id) => {
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         "https://ims-backend.indevconsultancy.in/admin-panel/purchase-items-by-id/",
//         { parchase_id: id }
//       );

//       if (response?.data) {
//         setSelectedPurchase(response.data);
//       } else {
//         setSelectedPurchase([]);
//       }
//     } catch (error) {
//       console.error("Error fetching purchase details:", error);
//       setSelectedPurchase([]);
//     } finally {
//       setLoading(false);
//       setShowModal(true);
//     }
//   };

//   const [stockVendor, setVendor] = useState([]);

//   useEffect(() => {
//     const fetchVendors = async () => {
//       try {
//         const res = await axios.get(
//           "https://ims-backend.indevconsultancy.in/admin-panel/vendor/"
//         );

//         if (Array.isArray(res.data)) {
//           setVendor(res.data);
//         } else if (res.data && res.data.data) {
//           setVendor(res.data.data);
//         }
//       } catch (err) {
//         console.error("Error fetching stock options:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchVendors();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   if (loading) return <p>Loading...</p>;

//   return (
//     <div className="container-fluid px-2">
//       <div className="row align-items-center justify-content-between py-2">
//         <div className="col-md-6 col-6">
//           <span className="fs-1">List Purchase Items</span>
//         </div>

//         <div className="col-md-6 col-6 text-end">
//           <div className="bg-light p-2 rounded d-inline-flex align-items-center justify-content-end">
//             <span className="me-1">List Purchase Items</span>
//             <span className="mx-1">/</span>
//             <Link to="/purchaseDashboard">Home</Link>
//           </div>
//         </div>
//       </div>

//       <div className="row g-3">
//         <div className="col-md-12">
//           <div className="card">
//             <div className="card-header border-info">
//               <form onSubmit={fetchPurchases}>
//                 <div className="row g-3">
//                   <div className="col-lg">
//                     <select
//                       className="form-control"
//                       name="vendor"
//                       value={filters.vendor}
//                       onChange={handleChange}
//                     >
//                       <option value="">Vendor Name</option>
//                       {stockVendor.map((vendor, index) => (
//                         <option key={index} value={vendor.vendor_id}>
//                           {vendor.vendor_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="col-lg">
//                     <input
//                       type="text"
//                       name="invoice"
//                       className="form-control"
//                       placeholder="Invoice No."
//                       value={filters.invoice}
//                       onChange={handleChange}
//                     />
//                   </div>

//                   <div className="col-lg">
//                     <input
//                       type="date"
//                       className="form-control"
//                       name="purchaseBy"
//                       value={filters.purchaseBy}
//                       onChange={handleChange}


//                     />
//                   </div>

//                   <div className="col-lg">
//                     <input
//                       type="date"
//                       name="date"
//                       className="form-control"
//                       value={filters.date}
//                       onChange={handleChange}
//                     />
//                   </div>

//                   <div className="col-lg-2">
//                     <button type="submit" className="btn btn-primary w-100">
//                       Search
//                     </button>
//                   </div>
//                   <div className="col-lg-1">
//                     <button
//                       type="button"
//                       className="btn btn-outline-dark w-100"
//                       onClick={() => {
//                         setFilters({
//                           vendor: "",
//                           invoice: "",
//                           purchaseBy: "",
//                           date: "",
//                         });
//                         fetchPurchases();
//                       }}
//                     >
//                       Reset
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>

//             <div className="card-body">
//               <div className="row g-0 align-items-center">
//                 <div className="col-sm-7 mb-3">
//                   <h6 className="fw-bold mb-0">
//                     Total Items(s): <span>{purchases.length}</span>
//                   </h6>
//                 </div>
//                 <div className="col-sm-5 mb-3 text-end">
//                   {getSelectedMenu === "purchasePO" ? (
//                     <button
//                       className="btn btn-primary btn-sm"
//                       type="button"
//                       onClick={() => navigate("/addPurchase")}
//                     >
//                       <i className="fas fa-plus"></i> Add
//                     </button>
//                   ) : (
//                     <button
//                       className="btn btn-primary btn-sm"
//                       onClick={handleExportCSV}
//                       type="button"
//                     >
//                       <i className="fas fa-file-export"></i> Report Export
//                     </button>
//                   )}
//                 </div>
//               </div>

//               <div className="table-responsive scrollbar">
//                 <table className="table text-center table-bordered table-striped fs--1 mb-0">
//                   <thead className="bg-primary text-white">
//                     <tr>
//                       <th>Vendor Name</th>
//                       <th>Invoice No.</th>
//                       <th>Date</th>
//                       <th>Purchase By</th>
//                       <th>Status</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {loading ? (
//                       <tr>
//                         <td colSpan="6">Loading...</td>
//                       </tr>
//                     ) : purchases.length === 0 ? (
//                       <tr>
//                         <td colSpan="6">No data available</td>
//                       </tr>
//                     ) : (
//                       purchases.map((purchase) => (
//                         <tr key={purchase.parchase_id}>
//                           <td>{purchase.vendor_name || "N/A"}</td>
//                           <td>{purchase.invoice_no}</td>
//                           <td>{formatDate(purchase.date)}</td>
//                           <td>{purchase.parchase_by}</td>
//                           <td>
//                             <span
//                               className={`badge ${purchase.status === 1
//                                 ? "bg-success"
//                                 : "bg-danger"
//                                 }`}
//                             >
//                               {purchase.status === 1 ? "Received" : "Pending"}
//                             </span>
//                           </td>
//                           <td>
//                             <div className="d-flex gap-2 justify-content-center">
//                               <button
//                                 className="btn btn-primary btn-sm"
//                                 type="button"
//                                 title="View"
//                                 onClick={() =>
//                                   handleView(purchase.parchase_id)
//                                 }
//                               >
//                                 <i className="fas fa-eye"></i>
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="d-flex justify-content-between align-items-center mt-3">
//                 <button className="btn btn-outline-primary btn-sm">
//                   Previous
//                 </button>
//                 <span>Page</span>
//                 <button className="btn btn-outline-primary btn-sm">Next</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modal */}
//       {showModal && (
//         <div
//           className="modal fade show"
//           style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-lg">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Purchase Details</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <div className="table-responsive scrollbar">
//                   <table className="table text-center table-bordered table-striped fs--1 mb-0">
//                     <thead className="bg-primary text-white">
//                       <tr>
//                         <th>Purchase ID</th>
//                         <th>Item Name</th>
//                         <th>Quantity</th>
//                         <th>Unit</th>
//                         <th>Total Amount</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {loading ? (
//                         <tr>
//                           <td colSpan="5">Loading...</td>
//                         </tr>
//                       ) : selectedPurchase.length === 0 ? (
//                         <tr>
//                           <td colSpan="5">No data available</td>
//                         </tr>
//                       ) : (
//                         selectedPurchase.map((item) => (
//                           <tr key={item.parchase_id || item.items_id}>
//                             <td>{item.parchase_id || "N/A"}</td>
//                             <td>{item.item_name || "N/A"}</td>
//                             <td>{item.quantity}</td>
//                             <td>{item.unit}</td>
//                             <td>{item.total_amount}</td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PurchasePO;
// pehle ka code 


import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { exportTableToPDF } from "../utils/exportPDF";

const PurchasePO = () => {
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user_id, setUserId] = useState("");
  const [getSelectedMenu, setSelectedMenu] = useState(
    localStorage.getItem("selectedMenu") || ""
  );

  // Filters
  const [filters, setFilters] = useState({
    vendor: "",
    invoice: "",
    purchaseBy: "",
    date: "",
  });

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    localStorage.setItem("selectedMenu", getSelectedMenu);
  }, [getSelectedMenu]);

  const [selectedPurchase, setSelectedPurchase] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const userid = localStorage.getItem("user_id");
    if (userid) setUserId(userid);
  }, []);

  useEffect(() => {
    if (user_id) {
      fetchPurchases();
    }
  }, [user_id, currentPage]);

  const fetchPurchases = async (e) => {
    if (e) e.preventDefault();

    setLoading(true);
    try {
      const params = {
        user_id,
        vendor: filters.vendor,
        invoice_no: filters.invoice,
        start_date: filters.purchaseBy,
        end_date: filters.date,
        page: currentPage,
        limit: itemsPerPage,
      };

      Object.keys(params).forEach(
        (key) =>
          (params[key] === "" || params[key] === null) && delete params[key]
      );

      const response = await axios.get(
        "https://ims-backend.indevconsultancy.in/admin-panel/purchases/",
        { params }
      );

      if (response.data && Array.isArray(response.data.results)) {
        setPurchases(response.data.results);
        setTotalPages(Math.ceil(response.data.total / itemsPerPage));
      } else {
        const allData = response.data || [];
        setTotalPages(Math.ceil(allData.length / itemsPerPage));
        const startIndex = (currentPage - 1) * itemsPerPage;
        setPurchases(allData.slice(startIndex, startIndex + itemsPerPage));
      }
    } catch (error) {
      console.error("Error fetching purchases:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB");
  };

  // ✅ Export API Call
  const handleExportCSV = async () => {
    setLoading(true);
    try {
      const params = {
        user_id,
        vendor_id: filters.vendor || "",
        from_date: filters.purchaseBy || "",
        to_date: filters.date || "",
      };

      Object.keys(params).forEach(
        (key) =>
          (params[key] === "" || params[key] === null) && delete params[key]
      );

      const response = await axios.get(
        "https://ims-backend.indevconsultancy.in/admin-panel/export-purchase-items/",
        {
          params,
          responseType: "blob", // file ke liye zaroori
        }
      );

      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);

      // Dynamic filename with filters
      let fileName = "purchase_items";
      if (filters.vendor) fileName += `_vendor-${filters.vendor}`;
      if (filters.purchaseBy && filters.date) {
        fileName += `_from-${filters.purchaseBy}_to-${filters.date}`;
      }
      link.download = `${fileName}.xlsx`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Export failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleExportPDF = () => {
    if (!purchases || purchases.length === 0) return alert("No data to export.");
    const dataKeys = Object.keys(purchases[0] || {}).slice(0, 9);
    const headers = ["S.No.", ...dataKeys];
    const rows = purchases.map((p, i) => [i + 1, ...dataKeys.map((h) => p[h] ?? "")]);
    exportTableToPDF({ title: "Purchase Order Report", headers, rows, filename: "purchase_items.pdf", filterInfo: `Total: ${rows.length}` });
  };

  const handleView = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/admin-panel/purchase-items-by-id/",
        { parchase_id: id }
      );
      if (response?.data) setSelectedPurchase(response.data);
      else setSelectedPurchase([]);
    } catch (error) {
      console.error("Error fetching purchase details:", error);
      setSelectedPurchase([]);
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  const [stockVendor, setVendor] = useState([]);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const res = await axios.get(
          "https://ims-backend.indevconsultancy.in/admin-panel/vendor/"
        );
        if (Array.isArray(res.data)) setVendor(res.data);
        else if (res.data && res.data.data) setVendor(res.data.data);
      } catch (err) {
        console.error("Error fetching stock options:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchVendors();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleViewEdit = (purchaseId) => {
    // Save to localStorage
    localStorage.setItem("purchase_id_edit", purchaseId);

    // Navigate to edit page
    navigate(`/editPurchase`);
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container-fluid px-2">
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-6">
          <span className="fs-1">List Purchase Items</span>
        </div>

        <div className="col-md-6 col-6 text-end">
          <div className="bg-light p-2 rounded d-inline-flex align-items-center justify-content-end">
            <span className="me-1">List Purchase Items</span>
            <span className="mx-1">/</span>
            <Link to="/purchaseDashboard">Home</Link>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="row g-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header border-info">
              <form
                onSubmit={(e) => {
                  setCurrentPage(1);
                  fetchPurchases(e);
                }}
              >
                <div className="row g-3">
                  <div className="col-lg">
                    <select
                      className="form-control"
                      name="vendor"
                      value={filters.vendor}
                      onChange={handleChange}
                    >
                      <option value="">Vendor Name</option>
                      {stockVendor.map((vendor, index) => (
                        <option key={index} value={vendor.vendor_id}>
                          {vendor.vendor_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg">
                    <input
                      type="text"
                      name="invoice"
                      className="form-control"
                      placeholder="Invoice No."
                      value={filters.invoice}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg">
                    <input
                      type="date"
                      className="form-control"
                      name="purchaseBy"
                      value={filters.purchaseBy}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg">
                    <input
                      type="date"
                      name="date"
                      className="form-control"
                      value={filters.date}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-primary w-100">
                      Search
                    </button>
                  </div>
                  <div className="col-lg-1">
                    <button
                      type="button"
                      className="btn btn-outline-dark w-100"
                      onClick={() => {
                        setFilters({
                          vendor: "",
                          invoice: "",
                          purchaseBy: "",
                          date: "",
                        });
                        setCurrentPage(1);
                        fetchPurchases();
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="card-body">
              <div className="row g-0 align-items-center">
                <div className="col-sm-7 mb-3">
                  <h6 className="fw-bold mb-0">
                    Total Items(s): <span>{purchases.length}</span>
                  </h6>
                </div>
                <div className="col-sm-5 mb-3 text-end">
                  {getSelectedMenu === "purchasePO" ? (
                    <button
                      className="btn btn-primary btn-sm"
                      type="button"
                      onClick={() => navigate("/addPurchase")}
                    >
                      <i className="fas fa-plus"></i> Add
                    </button>
                  ) : (
                    <>
                      <button
                        className="btn btn-primary btn-sm me-1"
                        onClick={handleExportCSV}
                        type="button"
                      >
                        <i className="fas fa-file-csv"></i> Export CSV
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={handleExportPDF}
                        type="button"
                      >
                        <i className="fas fa-file-pdf"></i> Export PDF
                      </button>
                    </>
                  )}
                </div>
              </div>

              {/* Table */}
              <div className="table-responsive scrollbar">
                <table className="table text-center table-bordered table-striped fs--1 mb-0">
                  <thead className="bg-primary text-white">
                    <tr>
                      <th>Purchase.No</th>
                      <th>Vendor Name</th>
                      <th>Invoice No.</th>
                      <th>Date</th>
                      <th>Purchase By</th>
                      <th>Total Amount</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6">Loading...</td>
                      </tr>
                    ) : purchases.length === 0 ? (
                      <tr>
                        <td colSpan="6">No data available</td>
                      </tr>
                    ) : (
                      purchases.map((purchase, index) => (
                        <tr key={purchase.parchase_id}>
                          <td>PU00{purchase.parchase_id}</td>
                          <td>{purchase.vendor_name || "N/A"}</td>
                          <td>{purchase.invoice_no}</td>
                          <td>{formatDate(purchase.date)}</td>
                          <td>{purchase.parchase_by}</td>
                          <td>{purchase.total_amount || "0"}</td>
                          <td>
                            <span
                              className={`badge ${purchase.status === 1
                                ? "bg-success"
                                : "bg-danger"
                                }`}
                            >
                              {purchase.status === 1
                                ? "Received"
                                : "Pending"}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2 justify-content-center">
                              <button
                                className="btn btn-primary btn-sm"
                                type="button"
                                title="View"
                                onClick={() =>
                                  handleView(purchase.parchase_id)
                                }
                              >
                                <i className="fas fa-eye"></i>
                              </button>

                              <button
                                className="btn btn-primary btn-sm"
                                type="button"
                                title="View"
                                onClick={() => handleViewEdit(purchase.parchase_id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>

                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                <span>
                  Page {currentPage} of {totalPages}
                </span>

                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(prev + 1, totalPages)
                    )
                  }
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Purchase Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="table-responsive scrollbar">
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>Purchase ID</th>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5">Loading...</td>
                        </tr>
                      ) : selectedPurchase.length === 0 ? (
                        <tr>
                          <td colSpan="5">No data available</td>
                        </tr>
                      ) : (
                        selectedPurchase.map((item) => (
                          <tr key={item.parchase_id || item.items_id}>
                            <td>{item.parchase_id || "N/A"}</td>
                            <td>{item.item_name || "N/A"}</td>
                            <td>{item.quantity}</td>
                            <td>{item.unit}</td>
                            <td>{item.total_amount}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default PurchasePO;
